import { Expose } from 'class-transformer';
import { IsNotEmpty, ValidateIf } from 'class-validator';

export class InternationalAddress {
  @Expose()
  @IsNotEmpty()
  @ValidateIf((o) => o.requiresValidation)
  streetAddress: string;

  @Expose()
  suiteNumber?: string;

  @Expose()
  @IsNotEmpty()
  @ValidateIf((o) => o.requiresValidation)
  city: string;

  @Expose()
  @IsNotEmpty()
  @ValidateIf((o) => o.requiresValidation)
  provState: string;

  @Expose()
  @IsNotEmpty()
  @ValidateIf((o) => o.requiresValidation)
  country: string;

  @Expose()
  @IsNotEmpty()
  @ValidateIf((o) => o.requiresValidation)
  postalZip: string;

  @Expose()
  requiresValidation?: boolean;
}
